var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "callact-main", style: `padding-top:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { "left-arrow": "" },
        on: { "click-left": _vm.goPrevious },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: { src: require("./images/c-left-arrow.png"), alt: "" },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "rules-bg",
          style: { "margin-top": `-${_vm.barHeight * 1 + 46}px` },
        },
        [
          _c("img", {
            staticClass: "callact-head",
            attrs: { src: require("./images/top-bg.png") },
          }),
          _c("div", { staticClass: "callact-con" }, [
            _c("div", { style: { height: `${_vm.barHeight * 1 + 46}px` } }),
            _c("div", { staticClass: "rule-tit1" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k111"))),
            ]),
            _c("div", { staticClass: "rule-con" }, [
              _c(
                "div",
                {
                  staticClass: "rule-tit2",
                  staticStyle: { "margin-top": "0" },
                },
                [_vm._v("1. " + _vm._s(_vm.$rt("lang.commonM.k277")))]
              ),
              _c("div", { staticClass: "rule-txt" }, [
                _vm._v(" ·"),
                _c("p", [_vm._v(_vm._s(_vm.$rt("lang.commonM.k278")))]),
              ]),
              _c("div", { staticClass: "rule-tit2" }, [
                _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k279"))),
              ]),
              _c(
                "div",
                { staticClass: "rule-txt" },
                [
                  _vm.unit === 1
                    ? [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$rt("lang.commonM.k383")))]),
                      ]
                    : [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$rt("lang.commonM.k280")))]),
                      ],
                ],
                2
              ),
              _c("div", { staticClass: "rule-tit2" }, [
                _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k281"))),
              ]),
              _c(
                "div",
                { staticClass: "rule-txt" },
                [
                  _vm.unit === 1
                    ? [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k416")))]),
                      ]
                    : [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k282")))]),
                      ],
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "rule-txt" },
                [
                  _vm.unit === 1
                    ? [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k415")))]),
                      ]
                    : [
                        _vm._v(" ·"),
                        _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k283")))]),
                      ],
                ],
                2
              ),
              _c("div", { staticClass: "rule-tit2" }, [
                _vm._v("4. " + _vm._s(_vm.$t("lang.commonM.k284"))),
              ]),
              _c("div", { staticClass: "rule-txt" }, [
                _vm._v(" ·"),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k285")))]),
              ]),
              _c("div", { staticClass: "rule-txt" }, [
                _vm._v(" ·"),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k286")))]),
              ]),
              _c("div", { staticClass: "rule-tit2" }, [
                _vm._v("5. " + _vm._s(_vm.$t("lang.commonM.k287"))),
              ]),
              _c("div", { staticClass: "rule-txt" }, [
                _vm._v(" ·"),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k288")))]),
              ]),
              _c("div", { staticClass: "rule-txt" }, [
                _vm._v(" ·"),
                _c("p", [_vm._v(_vm._s(_vm.$rt("lang.commonM.k289")))]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }